import React, { useCallback, useEffect, useState } from 'react';
import NavBar from '../components/NavBar';
import SideBar from '../components/SideBar';
import SalesDashboard from './SalesDashboard';
import SalesPipeline from './SalesPipeline';
// import CDashboard from "./Cleaner/CDashboard.js"
// import AddLead from "./AddLead"

// import Lead from "./Lead"
import Finance from './Finance/Finance';

// import AddLead from "./AddLead"

// import Lead from "./Lead"

import Contract from './Contract';
import PayrollDashboard from './Payroll/PayrollDashboard';
import ContractorPayroll from './Payroll/components/ContractorPayroll/ContractorPayroll';

import DashboardWorkForce from './WorkForce/components/DashboardWorkForce';
import EmployeeDirectory from './WorkForce/components/EmployeeDirectory';
import DashboardTimeCard from './WorkForce/components/DashboardTimeCard';
import LeaveSection from './WorkForce/components/LeaveSection';
import AttendanceDashboard from './WorkForce/components/AttendanceDashboard';
import AvailabilityManagement from './WorkForce/components/AvailabilityManagement';
import GpsTracking from './WorkForce/components/GpsTracking';
import WorkforceOpsDashboard from './WorkForce/components/WorkforceOpsDashboard';
import RostersAdmin from './WorkForce/components/RostersAdmin';
import UniformEquipmentDashboard from './WorkForce/components/UniformEquipmentDashboard';
import WorkforceForecast from './WorkForce/components/WorkforceForecast';
import RecruitmentManagement from './Recruitment/components/RecruitmentManagement';
import InventoryDashboard from './ResourceUpdate/components/InventoryDashboard';
import Applicants from './Recruitment/components/Applicants';
import InterviewManagement from './Recruitment/components/InterviewManagement';
import JobOffers from './Recruitment/components/JobOffers';
import BackgroundChecks from './Recruitment/components/BackgroundChecks';
import Lead from './Lead/components/Lead';
import CalendarSection from './Calender/components/CalenderSection';
import ProjectSection from './ProjectSection/components/ProjectSection';
import ServiceDashboard from './ServiceDashboard/components/ServiceDashboard';
import Timesheet from '../pages/Cleaner/Timesheet';
import Document from './WorkForce/components/Document';
import ResourceDashboard from './ResourceUpdate/components/ResourceDashboard';
import ItemDescriptionDashboard from './ResourceUpdate/components/ItemDescriptionDashboard';
import InventoryProductsDashboard from './ResourceUpdate/components/InventoryProductsDashboard';
import StockLevelsDashboard from './ResourceUpdate/components/StockLevelsDashboard';
import StockMovementsDashboard from './ResourceUpdate/components/StockMovementsDashboard';
import SuppliersDashboard from './ResourceUpdate/components/SuppliersDashboard';
import PurchaseOrdersDashboard from './ResourceUpdate/components/PurchaseOrdersDashboard';
import EquipmentDashboard from './ResourceUpdate/components/EquipmentDashboard';
import VehiclesDashboard from './ResourceUpdate/components/VehiclesDashboard';
import AllocationDashboard from './ResourceUpdate/components/AllocationDashboard';
import UsageTrackingDashboard from './ResourceUpdate/components/UsageTrackingDashboard';
import AuditsDashboard from './ResourceUpdate/components/AuditsDashboard';
import ForecastingDashboard from './ResourceUpdate/components/ForecastingDashboard';
import ResourcesOverviewDashboard from './ResourceUpdate/components/ResourcesOverviewDashboard';
import DashboardSummary from './DashboardSummary';
import TeamChatWorkspace from './chat/components/TeamChatWorkspace';
import '../styles/DashBoard.css';
import AllCustomers from './Customer/components/AllCustomers';
import AllInvoices from './AllInvoices';
import AllProposals from './Proposals/components/AllProposals';
import AddLead from './Lead/components/AddLead';
import AdminLiveChatWidget from '../components/livechat/AdminLiveChatWidget';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { QUICK_ACTIONS, buildAdminPageSearch } from '../utils/adminDashboardNav';

/** Profile/help routes: no Lead Overview tiles; outlet only. */
const ADMIN_STANDALONE_PAGE_RE =
  /^\/(profile-dashboard(?:\/[^/]+)?|profile|account-settings|notifications|help-support|activity-overview|device-sessions|user-activity|dashboard-preferences|data-usage-policy|terms-conditions|faq|report-issue|new-ticket|active-sessions|login-history|role-profiles|branch-management)\/?$/;

/** Support Management nested routes: same as standalone (no tiles) but main NavBar + SideBar stay visible. */
const ADMIN_SUPPORT_PAGE_RE = /^\/(admin\/)?support-management(\/.*)?$/;

function DashBoard() {
  const location = useLocation();
  const navigate = useNavigate();
  const hideDashboardTiles =
    ADMIN_STANDALONE_PAGE_RE.test(location.pathname) || ADMIN_SUPPORT_PAGE_RE.test(location.pathname);
  const [activePage, setActivePage] = useState('dashboard');
  const [showAddLead, setShowAddLead] = useState(false);
  const [approvedCompanies, setApprovedCompanies] = useState([]);
  const [workforceConfig, setWorkforceConfig] = useState(null);

  const goToAdminPage = useCallback(
    (page, extra = {}) => {
      const search = buildAdminPageSearch(page, extra);
      navigate({ pathname: '/', search }, { replace: true });
      setActivePage(page);
    },
    [navigate],
  );

  const handleQuickAccess = useCallback(
    (actionId) => {
      const action = QUICK_ACTIONS.find((a) => a.id === actionId);
      if (!action) return;
      if (action.type === 'modal' && action.modal === 'addLead') {
        setShowAddLead(true);
        return;
      }
      if (action.page) {
        const extra = { action: action.action, tab: action.tab };
        goToAdminPage(action.page, extra);
      }
    },
    [goToAdminPage],
  );

  const handleGoToAddContractor = () => {
    const backToPayroll = () => {
      setWorkforceConfig(null);
      setActivePage('contractor-payroll');
    };
    setWorkforceConfig({
      initialTab: 'Contractor',
      autoOpenAddMember: true,
      onContractorAdded: backToPayroll,
      onCancelAddMember: backToPayroll,
    });
    setActivePage('workforce');
  };

  useEffect(() => {
    if ((location.pathname || '') !== '/') return;
    const params = new URLSearchParams(location.search || '');
    const page = params.get('page');
    if (!page) return;

    // Fold Licences & Compliance into Documents hub
    if (page === 'licences-compliance') {
      params.set('page', 'document-workforce');
      params.set('tab', 'compliance');
      navigate(
        { pathname: '/', search: `?${params.toString()}` },
        { replace: true },
      );
      setActivePage('document-workforce');
      return;
    }

    const map = {
      dashboard: 'dashboard',
      pipeline: 'pipeline',
      lead: 'lead',
      proposals: 'proposals',
      services: 'services',
      calendar: 'calendar',
      customer: 'customer',
      allInvoice: 'allInvoice',
      'time-card': 'time-card',
      chat: 'chat',
      project: 'project',
      leave: 'leave',
      timesheet: 'timesheet',
      'employee-payroll': 'employee-payroll',
      'inventory-update': 'inventory-update',
      'item-description': 'item-description',
      'stock-levels': 'stock-levels',
      'stock-movements': 'stock-movements',
      'suppliers': 'suppliers',
      'purchase-orders': 'purchase-orders',
      'equipment': 'equipment',
      'vehicles': 'vehicles',
      'allocation': 'allocation',
      'usage-tracking': 'usage-tracking',
      'audits': 'audits',
      'resource-forecasting': 'resource-forecasting',
      'resources-dashboard': 'resources-dashboard',
      workforce: 'workforce',
      'team-member': 'team-member',
      'workforce-dashboard': 'workforce-dashboard',
      availability: 'availability',
      'gps-tracking': 'gps-tracking',
      rosters: 'rosters',
      'uniform-equipment': 'uniform-equipment',
      attendance: 'attendance',
      forecasting: 'forecasting',
      recruitment: 'recruitment',
      'recruitment-applicants': 'recruitment-applicants',
      'recruitment-interviews': 'recruitment-interviews',
      'recruitment-offers': 'recruitment-offers',
      'recruitment-background': 'recruitment-background',
      'document-workforce': 'document-workforce',
      finance: 'finance',
      Contract: 'Contract',
      'contractor-payroll': 'contractor-payroll',
      'sales-pipeline': 'sales-pipeline',
    };
    const next = map[page];
    if (!next) return;
    if (next === 'sales-pipeline') {
      const pipelineId = params.get('pipelineId') || '';
      setActivePage((prev) => {
        if (
          prev &&
          typeof prev === 'object' &&
          prev.page === 'sales-pipeline' &&
          prev.pipelineId === pipelineId
        ) {
          return prev;
        }
        return { page: 'sales-pipeline', pipelineId };
      });
      return;
    }
    setActivePage(next);
  }, [location.pathname, location.search, navigate]);

  return (
    <div className="dashboard-layout">
      <NavBar onAddLead={() => setShowAddLead(true)} />

      {showAddLead && (
        <AddLead
          onSave={() => setShowAddLead(false)}
          onCancel={() => setShowAddLead(false)}
        />
      )}

      <div className="dashboard-body">
        <SideBar setActivePage={setActivePage} />

        {/* Content Area */}
        <main
          className={`dashboard-content${hideDashboardTiles ? ' dashboard-content--standalone' : ''}`}
        >
          {!hideDashboardTiles && (
            <>
              {activePage === 'dashboard' && (
                <DashboardSummary
                  leads={approvedCompanies}
                  onQuickAccess={handleQuickAccess}
                />
              )}
              {activePage === 'pipeline' && <SalesDashboard />}

              {activePage === 'lead' && (
                <Lead setApprovedCompanies={setApprovedCompanies} />
              )}
              {/* Render SalesPipeline dynamically */}
              {activePage.page === 'sales-pipeline' && activePage.pipelineId && (
                <SalesPipeline
                  approvedCompanies={approvedCompanies}
                  pipelineId={activePage.pipelineId} // pass the selected pipeline
                />
              )}
              {activePage === 'CTimesheet' && <Timesheet />}
              {/* {activePage === 'CDashBoard' && <CDashboard />} */}

              {/* {activePage === 'lead' && <Lead />} */}
              {activePage === 'timesheet' && <Timesheet />}
              {activePage === 'calendar' && <CalendarSection />}
              {activePage === 'chat' && <TeamChatWorkspace />}
              {activePage === 'customer' && <AllCustomers />}
              {activePage === 'allInvoice' && <AllInvoices />}
              {activePage === 'proposals' && <AllProposals />}
              {/* {activePage === 'services' && <AddServices />} */}
              {/* {activePage === 'resources' && <CreateDeal />} */}
              {activePage === 'workforce' && (
                <DashboardWorkForce {...(workforceConfig || {})} />
              )}
              {activePage === 'services' && <ServiceDashboard />}
              {activePage === 'resources' && <ResourceDashboard />}
              {activePage === 'team-member' && <EmployeeDirectory />}
              {activePage === 'workforce-dashboard' && (
                <WorkforceOpsDashboard />
              )}
              {activePage === 'availability' && <AvailabilityManagement />}
              {activePage === 'gps-tracking' && <GpsTracking />}
              {activePage === 'rosters' && (
                <RostersAdmin />
              )}
              {activePage === 'uniform-equipment' && (
                <UniformEquipmentDashboard />
              )}
              {activePage === 'attendance' && <AttendanceDashboard />}
              {activePage === 'forecasting' && <WorkforceForecast />}
              {activePage === 'recruitment' && <RecruitmentManagement />}
              {activePage === 'recruitment-applicants' && <Applicants />}
              {activePage === 'recruitment-interviews' && (
                <InterviewManagement />
              )}
              {activePage === 'recruitment-offers' && <JobOffers />}
              {activePage === 'recruitment-background' && <BackgroundChecks />}
              {activePage === 'time-card' && <DashboardTimeCard />}
              {activePage === 'leave' && <LeaveSection />}
              {activePage === 'project' && <ProjectSection />}
              {activePage === 'document-workforce' && <Document />}
              {activePage === 'item-description' && (
                <InventoryProductsDashboard />
              )}
              {activePage === 'stock-levels' && <StockLevelsDashboard />}
              {activePage === 'stock-movements' && <StockMovementsDashboard />}
              {activePage === 'suppliers' && <SuppliersDashboard />}
              {activePage === 'purchase-orders' && <PurchaseOrdersDashboard />}
              {activePage === 'equipment' && <EquipmentDashboard />}
              {activePage === 'vehicles' && <VehiclesDashboard />}
              {activePage === 'allocation' && <AllocationDashboard />}
              {activePage === 'usage-tracking' && <UsageTrackingDashboard />}
              {activePage === 'audits' && <AuditsDashboard />}
              {activePage === 'resource-forecasting' && <ForecastingDashboard />}
              {activePage === 'resources-dashboard' && (
                <ResourcesOverviewDashboard />
              )}
              {activePage === 'inventory-update' && <InventoryDashboard />}
              {activePage === 'finance' && <Finance />}
              {activePage === 'Contract' && <Contract />}
              {activePage === 'employee-payroll' && <PayrollDashboard />}
              {activePage === 'contractor-payroll' && (
                <ContractorPayroll onGoToAddContractor={handleGoToAddContractor} />
              )}
            </>
          )}

          <Outlet />
        </main>
      </div>
      <AdminLiveChatWidget />
    </div>
  );
}

export default DashBoard;
